import type { ChatsProvider } from './types';

const STAGE = false;
const DEV = process.env.NODE_ENV === 'development';

/* global APP_MANIFEST */

type Meta = {
  alias: string;
  name: string;
  stage: boolean;
  provider: ChatsProvider;
};

if (!process.env.APP_MANIFEST || !process.env.APP_MANIFEST.provider) {
  throw new Error('APP_MANIFEST is required');
}

export const meta: Meta = {
  alias: process.env.APP_MANIFEST.alias,
  name: process.env.APP_MANIFEST.name,
  stage: STAGE && DEV,
  provider: process.env.APP_MANIFEST.provider as ChatsProvider
};
